import { render } from "./DepositsVerificationSuccessful.vue?vue&type=template&id=756130e8&scoped=true"
import script from "./DepositsVerificationSuccessful.vue?vue&type=script&lang=js"
export * from "./DepositsVerificationSuccessful.vue?vue&type=script&lang=js"

import "./DepositsVerificationSuccessful.vue?vue&type=style&index=0&id=756130e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756130e8"]])

export default __exports__